let modules = require.context('./modules', false, /([A-Z]|\w+)\.(js)$/)
let obj = {}
modules.keys().forEach((item, index) => {
  let modulesItem = modules(item).default
  Object.assign(obj, modulesItem)
})
export default obj



// WEBPACK FOOTER //
// ./src/filter/index.js